import React from 'react';
import { Player, PlayerWithLeagueContext } from '../generated-api';
import PlayerAvatar from './common/PlayerAvatar';

interface SimplePlayerSelectionGridProps {
  players: (Player | PlayerWithLeagueContext)[];
  selectedPlayers: Set<string>;
  onSelectionChange: (selectedPlayers: Set<string>) => void;
}

const SimplePlayerSelectionGrid: React.FC<SimplePlayerSelectionGridProps> = ({
  players,
  selectedPlayers,
  onSelectionChange
}) => {
  const handlePlayerToggle = (playerId: string) => {
    const newSelection = new Set(selectedPlayers);
    if (newSelection.has(playerId)) {
      newSelection.delete(playerId);
    } else {
      newSelection.add(playerId);
    }
    onSelectionChange(newSelection);
  };

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3">
      {players.map((player) => {
        const isSelected = selectedPlayers.has(player.id);
        return (
          <button
            data-track="player_select_card"
            key={player.id}
            type="button"
            onClick={() => handlePlayerToggle(player.id)}
            className={`p-4 rounded-lg border text-left transition-colors ${
              isSelected
                ? 'border-primary-500 bg-primary-50 text-primary-900'
                : 'border-edge bg-surface text-body hover:bg-surface-hover'
            }`}
          >
            <div className="flex items-center space-x-3">
              <div className="flex-shrink-0">
                <PlayerAvatar name={player.name} imageUrl={player.imageUrl} size="small" />
              </div>
              <div className="flex-1 min-w-0">
                <div className="font-medium truncate">{player.name}</div>
                <div className="text-sm opacity-75">
                  Rating: {('leagueRating' in player && player.leagueRating) ? Math.round(player.leagueRating.rating || 0) : '25'}
                </div>
              </div>
              {isSelected && (
                <div className="flex-shrink-0">
                  <div className="w-5 h-5 bg-primary-500 rounded-full flex items-center justify-center">
                    <svg className="w-3 h-3 text-white" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                    </svg>
                  </div>
                </div>
              )}
            </div>
          </button>
        );
      })}
    </div>
  );
};

export default SimplePlayerSelectionGrid;